import { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import './FeedbackModal.css';

export default function FeedbackModal({ isOpen, onClose, user, userProfile }) {
    const [feedback, setFeedback] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!feedback.trim()) return;

        setIsSubmitting(true);
        try {
            await addDoc(collection(db, 'feedback'), {
                text: feedback,
                userId: user?.uid || 'anonymous',
                userName: userProfile?.name || 'Anonymous',
                userEmail: user?.email || 'N/A',
                url: window.location.href,
                createdAt: serverTimestamp()
            });
            setIsSuccess(true);
            setFeedback('');
        } catch (error) {
            console.error("Error submitting feedback:", error);
            alert("Oops! Something went wrong. Please try again later.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        setIsSuccess(false);
        onClose();
    };

    return (
        <div className="feedback-overlay" onClick={handleClose}>
            <div className="feedback-content" onClick={e => e.stopPropagation()}>
                {isSuccess ? (
                    <div className="feedback-success">
                        <div className="success-icon">✨</div>
                        <h2>Thank You!</h2>
                        <p>Your feedback helps us make Revlry even better. We really appreciate it!</p>
                        <button className="done-btn" onClick={handleClose}>Done</button>
                    </div>
                ) : (
                    <>
                        <h2>Help us improve 🚀</h2>
                        <p>Found a bug? Have a feature request? Let us know what's on your mind.</p>
                        <form onSubmit={handleSubmit}>
                            <textarea
                                value={feedback}
                                onChange={(e) => setFeedback(e.target.value)}
                                placeholder="Type your feedback here..."
                                required
                                autoFocus
                            ></textarea>
                            <div className="feedback-actions">
                                <button type="button" className="cancel-link" onClick={handleClose}>Cancel</button>
                                <button type="submit" className="submit-feedback-btn" disabled={isSubmitting || !feedback.trim()}>
                                    {isSubmitting ? 'Sending...' : 'Send Feedback'}
                                </button>
                            </div>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
}
